define(function (require) {
    "use strict";

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    var _ = require('underscore');
    var BaseController = require('web-agent-assets-js/BaseController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var WidgetsController = BaseController.extend(function () {
        var hasMessaging = lpTag.WebAgent.logicController.hasMessagingFeature();

        this.mandatoryWidgets = ["AgentActionsWidgetContainer"];
        this.widgetsDefaultBehavior = [
            {
                type: "core",
                name: "PCIDataWidget",
                order: -1,
                isSupported: lpTag.WebAgent.logicController.hasPCIDataWidgetSupport(),
                isNotConfigurable: true
            },
            {
                type: "core",
                name: "CoBrowseWidget",
                order: 1000,
                isSupported: lpTag.WebAgent.logicController.hasCoBrowseFeature(),
                isNotConfigurable: true
            },
            {
                type: "core",
                name: "VisitInfoWidget",
                order: 1,
                isSupported: true
            },
            {
                type: "core",
                name: "ConsumerInfoWidget",
                order: 2,
                isSupported: hasMessaging
            },
            {
                type: "core",
                name: "PreDefinedWidget",
                order: 3,
                isSupported: true
            },
            {
                type: "core",
                name: "PageNavigationWidget",
                order: 4,
                isSupported: true
            },
            {
                type: "core",
                name: "AgentActionsWidgetContainer",
                order: 5,
                isSupported: true
            },
            {
                type: "core",
                name: "AgentSummaryWidget",
                order: 6,
                isSupported: hasMessaging
            },
            {
                type: "core",
                name: "ChatHistoryWidget",
                order: 7,
                isSupported: true
            },
            {
                type: "core",
                name: "OperatorAlertsWidget",
                order: 8,
                isSupported: !lpTag.WebAgent.logicController.isLE2()
            },
            {
                type: 'core',
                name: 'AIAssistWidget',
                order: 9,
                isSupported: agentLEManager.hasAIAssistWidgetFeature()
            }
        ];

        _registerToCrossModule.call(this);
    });

    WidgetsController.prototype.applicationType = 'WidgetsController';

    WidgetsController.prototype.getWidgets = function (configuredWidgets, includeNotConfigurableWidgets) {
        var defaultWidgets,
            mergedWidgets,
            customWidgets;

        defaultWidgets = _.clone(this.widgetsDefaultBehavior, true);
        configuredWidgets = configuredWidgets || [];

        customWidgets = _.filter(configuredWidgets, {type: "iFrame"});

        if (customWidgets.length === configuredWidgets.length) {
            mergedWidgets = defaultWidgets;
            for (var i = 0; i < customWidgets.length; i++) {
                customWidgets[i].order += defaultWidgets.length;
            }
        } else {
            mergedWidgets = _getMergedCoreWidgets(defaultWidgets, configuredWidgets);
        }

        mergedWidgets = Array.prototype.concat(mergedWidgets, customWidgets);

        return _removeUnsupportedWidgets(mergedWidgets, includeNotConfigurableWidgets);
    };


    WidgetsController.prototype.isMandatoryWidget = function (widgetName) {
        return this.mandatoryWidgets.indexOf(widgetName) >= 0;
    };

    WidgetsController.prototype.isWidgetConfigurable = function (widgetName) {
        var widget = _.find(this.widgetsDefaultBehavior, {name: widgetName});
        return !widget || (widget.isSupported && !widget.isNotConfigurable);
    };

    function _removeUnsupportedWidgets(widgets, includeNotConfigurableWidgets) {
        var supportedWidgets = [];
        widgets = _.sortBy(widgets, "order");
        for (var i = 0; i < widgets.length; i++) {
            if (widgets[i].isSupported !== false && (includeNotConfigurableWidgets || !widgets[i].isNotConfigurable)) {
                supportedWidgets.push(widgets[i]);
                supportedWidgets[supportedWidgets.length - 1].order = supportedWidgets.length;
            }
        }

        return supportedWidgets;
    }

    function _getMergedCoreWidgets(defaultWidgets, configuredWidgets) {
        var mergedWidgets = [],
            defaultWidget,
            widget;

        for (var i = 0; i < defaultWidgets.length; i++) {
            defaultWidget = _.clone(defaultWidgets[i]);

            widget = _.find(configuredWidgets, {name: defaultWidget.name});
            widget = widget ? _.extend(defaultWidget, widget) : defaultWidget;

            mergedWidgets.push(widget);
        }

        return mergedWidgets;
    }

    function _registerToCrossModule() {
        var webAgentChannel = agentLEManager.channelLE();
        var webAgentMediaCodes = agentLEManager.getLEMediaCodesWebAgent();

        if (webAgentChannel && webAgentMediaCodes) {
            /*jshint validthis:true */
            webAgentChannel.reply(webAgentMediaCodes.reqres.getWidgets, this.getWidgets.bind(this));
            /*jshint validthis:true */
            webAgentChannel.reply(webAgentMediaCodes.reqres.isMandatoryWidget, this.isMandatoryWidget.bind(this));
            /*jshint validthis:true */
            webAgentChannel.reply(webAgentMediaCodes.reqres.isWidgetConfigurable, this.isWidgetConfigurable.bind(this));
        }
    }

    return WidgetsController;
});
